import type { RouteLocationNormalized } from "vue-router";

import { Schulform } from "@core/asd/types/schule/Schulform";
import type { SchuelerVermerkartZusammenfassung } from "@core/core/data/schueler/SchuelerVermerkartZusammenfassung";
import { BenutzerKompetenz } from "@core/core/types/benutzer/BenutzerKompetenz";
import { ServerMode } from "@core/core/types/ServerMode";

import type { VermerkartenDatenProps } from "~/components/schule/kataloge/vermerkarten/daten/VermerkartenDatenProps";
import { routeSchuelerVermerke } from "~/router/apps/schueler/vermerke/RouteSchuelerVermerke";
import { type RouteVermerkarten, routeVermerkarten } from "~/router/apps/schule/kataloge/vermerkarten/RouteVermerkarten";
import { RouteManager } from "~/router/RouteManager";
import { RouteNode } from "~/router/RouteNode";

const VermerkartenDaten = () => import("~/components/schule/kataloge/vermerkarten/daten/VermerkartenDaten.vue");

export class RouteVermerkartenDaten extends RouteNode<any, RouteVermerkarten> {

	public constructor() {
		super(Schulform.values(), [BenutzerKompetenz.KATALOG_EINTRAEGE_ANSEHEN, BenutzerKompetenz.KATALOG_EINTRAEGE_AENDERN],
			"schule.vermerke.daten", "daten", VermerkartenDaten);
		super.mode = ServerMode.STABLE;
		super.propHandler = (route) => this.getProps(route);
		super.text = "Vermerkart";
	}

	gotoSchueler = async (schuelerVermerkartZusammenfassung: SchuelerVermerkartZusammenfassung) => {
		await RouteManager.doRoute(routeSchuelerVermerke.getRoute({ id: schuelerVermerkartZusammenfassung.id }));
	};

	public getProps(to: RouteLocationNormalized): VermerkartenDatenProps {
		return {
			patch: routeVermerkarten.data.patch,
			manager: () => routeVermerkarten.data.manager,
			gotoSchueler: this.gotoSchueler,
		};
	}

}

export const routeVermerkartenDaten = new RouteVermerkartenDaten();

